const SESSION_STORAGE_KEY = 'reglesGestionActif';

export interface ReglesGestionState {
    actif: boolean;
    panneauOuvert: boolean;
    cleMiseEnAvant: string | null;
}

export const initialState: ReglesGestionState = {
    actif: sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true',
    panneauOuvert: false,
    cleMiseEnAvant: null,
};

export const state: ReglesGestionState = {
    ...initialState,
};

export function persisterActif(actif: boolean): void {
    sessionStorage.setItem(SESSION_STORAGE_KEY, actif ? 'true' : 'false');
}
